import React from 'react';
// styles
import styled from 'styled-components';
// compoenents
import GridRow from './gridRow';

const StyledHr = styled.hr`
  background-color: var(--grey-mouse);
  height: 1px;
  border: 0;
  margin: 0 auto;
  width: 100%;
`;

const Separator = ({ className }) => (
  <GridRow>
    <StyledHr />
  </GridRow>
);

export default React.memo(Separator);
